<template>
	<div class="questionMessage">
		<van-nav-bar
			fixed
			placeholder
			safe-area-inset-top
			title="我的消息"
			left-text=""
			right-text=""
			@click-left="handleClickLeft"
			@click-right="handleClickRight"
		/>
		<div class="questionMessage_tabs">
			<div
				:class="
					item.value === tabSelect
						? 'questionMessage_tabs_item active'
						: 'questionMessage_tabs_item'
				"
				v-for="(item, index) in tabList"
				:key="index"
				@click="() => handleSelectTab(item.value)"
			>
				{{ item.name }}
			</div>
		</div>
		<div class="questionMessage_opration">
			<div
				class="questionMessage_opration_item"
				@click="() => handleRead()"
			>
				选中已读
			</div>
			<div
				class="questionMessage_opration_item"
				@click="() => handleRead('all')"
			>
				全部已读
			</div>
			<div
				class="questionMessage_opration_item"
				@click="() => handleDelete()"
			>
				选中删除
			</div>
			<div
				class="questionMessage_opration_item"
				@click="() => handleDelete('all')"
			>
				全部删除
			</div>
		</div>
		<div class="questionMessage_list">
			<van-list
				v-model="listLoading"
				:finished="pages.page >= pages.totalPages"
				@load="fetchList"
				finished-text="没有更多了"
			>
				<div
					class="questionMessage_item"
					v-for="(item, index) in list"
					:key="index"
					@click.stop="() => handleSelectItem(item.id)"
				>
					<div class="questionMessage_item_check">
						<div
							:class="
								computedCheck(item.id)
									? 'questionMessage_item_check_circle active'
									: 'questionMessage_item_check_circle'
							"
						>
							<van-icon
								name="checked"
								size=".19rem"
								color="#c32929"
								v-if="computedCheck(item.id)"
							/>
						</div>
					</div>
					<div class="questionMessage_item_main">
						<div class="questionMessage_item_main_info">
							<div class="questionMessage_item_main_info_title">
								<div
									class="questionMessage_item_main_info_title_point"
									v-if="item.readStatus === 0"
								></div>
								{{ item.title }}
							</div>
							<div class="questionMessage_item_main_info_time">
								{{ item.createTimeStr }}
							</div>
						</div>
						<div
							class="questionMessage_item_main_info_btn"
							@click.stop="() => handleToRecord(item.id)"
						>
							查看及回复
						</div>
					</div>
				</div>
			</van-list>
		</div>
		<tabBar :active="2" />
	</div>
</template>
<script>
import tabBar from "@/app/components/tabBar.vue";
import { NavBar, Icon, List, Dialog, Toast } from "vant";

export default {
	components: {
		[List.name]: List,
		[NavBar.name]: NavBar,
		[Icon.name]: Icon,
		tabBar
	},
	computed: {
		computedCheck() {
			return function(value) {
				let checks = this.checks;
				if (checks.includes(value)) {
					return true;
				} else {
					return false;
				}
			};
		}
	},
	data() {
		return {
			tabList: [
				{ name: "全部消息", value: -1 },
				{ name: "未读", value: 0 },
				{ name: "已读", value: 1 }
			],
			tabSelect: -1,
			messageList: [],
			checks: [],
			// 列表
			list: [],
			listLoading: true,
			pages: {
				page: 1,
				totalPages: 2
			}
		};
	},
	mounted() {
		this.initFetchList();
	},
	methods: {
		handleClickLeft() {},
		handleClickRight() {},
		async handleDelete(value) {
			let checks = this.checks;
			if (!value && !checks.length) {
				return Toast("请先选中");
			}
			Dialog.confirm({
				title: "提示",
				message: "删除操作无法撤销"
			}).then(async () => {
				if (value) {
					await this.h5Ajax(
						"post",
						"$/inbox/updateInboxStatus",
						{
							readStatus: 2,
							jobInboxIds: "",
							isAll: false
						},
						true
					);
				} else {
					await this.h5Ajax(
						"post",
						"$/inbox/updateInboxStatus",
						{
							readStatus: 2,
							jobInboxIds: checks.join(","),
							isAll: false
						},
						true
					);
				}
				this.initFetchList();
				h5CloseLoad();
			});
		},
		async handleRead(value) {
			let checks = this.checks;
			if (!value && !checks.length) {
				return Toast("请先选中");
			}
			Dialog.confirm({
				title: "提示",
				message: "已读操作无法撤销"
			}).then(async () => {
				if (value) {
					await this.h5Ajax(
						"post",
						"$/inbox/updateInboxStatus",
						{
							readStatus: 1,
							jobInboxIds: "",
							isAll: true
						},
						true
					);
				} else {
					await this.h5Ajax(
						"post",
						"$/inbox/updateInboxStatus",
						{
							readStatus: 1,
							jobInboxIds: checks.join(","),
							isAll: false
						},
						true
					);
				}
				this.initFetchList();
				h5CloseLoad();
			});
		},
		initFetchList() {
			this.pages = { page: 1, totalPages: 2 };
			this.checks = [];
			this.fetchList();
		},
		async fetchList() {
			let { page, totalPages } = this.pages;
			if (page >= totalPages) {
				return;
			}
			this.listLoading = true;
			let { content: list, ...pages } = await this.h5Ajax(
				"get",
				"$/inbox/inboxListPage",
				{
					page,
					size: 10,
					readStatus: this.tabSelect
				},
				true
			);
			h5CloseLoad();
			this.listLoading = false;
			this.list = page === 1 ? list : [...this.list, ...list];
			this.pages = { ...pages, page: page + 1 };
		},
		handleToRecord(id) {
			this.$router.push({
				path: "/question/message/record",
				query: { id }
			});
		},
		handleSelectItem(value) {
			let checks = this.checks;
			let index = checks.indexOf(value);
			if (index >= 0) {
				this.checks.splice(index, 1);
			} else {
				this.checks.push(value);
			}
		},
		handleSelectTab(value) {
			this.tabSelect = value;
			this.initFetchList();
		}
	}
};
</script>

<style>
@import "./index.css";
</style>



// WEBPACK FOOTER //
// src/app/pages/question/message/index.vue